import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M5,3.53574229 L5,7.80015158 C5,9.42849428 6.22362615,10.4000001 8,10.4000001 C9.78310254,10.4000001 11,9.42849428 11,7.80015158 L11,3.53574229 C11,3.17858077 11.1666667,3 11.5,3 C11.8333333,3 12,3.17858077 12,3.53574229 L12,7.85398109 C12,9.94660331 10.334855,11.4000001 8,11.4000001 C5.66514498,11.4000001 4,9.8927738 4,7.80015158 L4,3.53574229 C4,3.17858077 4.16666667,3 4.5,3 C4.83333333,3 5,3.17858077 5,3.53574229 Z M2.5,13 L13.5,13 C13.7761424,13 14,13.2238576 14,13.5 C14,13.7761424 13.7761424,14 13.5,14 L2.5,14 C2.22385763,14 2,13.7761424 2,13.5 C2,13.2238576 2.22385763,13 2.5,13 Z"/>
  </svg>
);
